import { IAppointmentSlot, SchedulingServiceSessionType } from '@sondermind/utilities/models-scheduling';
import { SessionPreference } from '@sondermind/utilities/models-session';

/**
 * The radio's `SessionPreference` and scheduling-service's `SchedulingServiceSessionType` are separate
 * vocabularies whose values do not line up (`inPerson` vs `in_person`), so this mapping is explicit.
 * `convertSessionTypeToSchedulingServiceSessionType` in the scheduling lib maps the neighbouring
 * `SessionType` enum and would resolve a `SessionPreference.IN_PERSON` to hybrid via its default branch.
 * A null value means the client expressed no modality, so nothing is filtered.
 */
const REQUIRED_MODALITY: Record<SessionPreference, SchedulingServiceSessionType | null> = {
  [SessionPreference.VIDEO]: SchedulingServiceSessionType.VIRTUAL,
  [SessionPreference.IN_PERSON]: SchedulingServiceSessionType.IN_PERSON,
  [SessionPreference.NO_PREFERENCE]: null,
};

/**
 * Narrows slots to those the client can actually book in their chosen modality. `hybrid` means "either",
 * so it satisfies both preferences. A slot carrying no modality at all fails open and is always kept —
 * absent data must not read as "unavailable".
 */
export function filterSlotsByPreference(
  slots: IAppointmentSlot[],
  preference: SessionPreference
): IAppointmentSlot[] {
  const required = REQUIRED_MODALITY[preference];
  if (!required) { return slots }

  return slots.filter(
    ({ sessionType }) => sessionType == null
      || sessionType === SchedulingServiceSessionType.HYBRID
      || sessionType === required
  );
}
